import React, { forwardRef } from 'react';
import SearchPageProductListItem from './SearchPageProductListItem';
import { array, bool, func, node, number, object, string } from 'prop-types';
import PageNavButtons from './PageNavButtons';

const DUMMY_PRODUCTS_AMOUNT = 8;

const SearchPageProductList = forwardRef(({ isMobile, productList, searchLoading, _collectionHandle, _children, _searchQuery, _setProductList, totalPages, curPage, paginateUser }, ref) => {
    const view = 'grid';

    return (<ul
        ref={ref}
        className={'search-page--product-list'}>
        {(searchLoading === false && !productList.length) && (<p
            style={{ height: '24px' }}>No products match your search criteria, please try again.</p>)}
        <div
            className={`search-page--product-list-inner ${view}`}>
            {(productList.length > 0 && searchLoading === false) && productList.map((product, i) => (
                <SearchPageProductListItem
                    index={i}
                    key={product.id}
                    isMobile={isMobile}
                    title={product.title}
                    handle={product.handle}
                    imageUrl={product.imageUrl}
                    price={product.price}
                    compareAtPrice={product.compareAtPrice}
                    availableForSale={product.availableForSale}
                    avgRating={product.avgRating}
                    totalReviews={product.totalReviews}
                    searchLoading={searchLoading}
                    isFeatured={product.isFeatured}
                    inventoryLevelId={product?.availableInventoryLevels?.at(0)?.id ?? 0}
                    availableQuantity={product?.availableInventoryLevels?.at(0)?.availableQuantity ?? 0}
                    bypassNegativeQuantity={product?.availableInventoryLevels?.at(0)?.bypassNegativeQuantity ?? false}
                    view={view}
                />
            ))}
            {searchLoading === true && new Array(DUMMY_PRODUCTS_AMOUNT).fill(0).map((item, idx) => (
                <SearchPageProductListItem
                    index={idx}
                    key={item}
                    isMobile={isMobile}
                    searchLoading={searchLoading} />
            ))}
        </div>
        {!searchLoading && productList.length > 0 ? (<div
            style={{
                display: 'flex',
                justifyContent: 'flex-end',
            }}>
            <PageNavButtons
                curPage={curPage}
                totalPages={totalPages}
                paginateUser={paginateUser}
            />
        </div>) : null}
    </ul>);
});

SearchPageProductList.displayName = 'SearchPageProductList';

SearchPageProductList.propTypes = {
    isMobile: bool,
    productList: array,
    searchLoading: bool,
    _collectionHandle: string,
    _children: node,
    _searchQuery: object,
    _setProductList: func,
    totalPages: number,
    curPage: number,
    paginateUser: func,
};

SearchPageProductList.defaultProps = {
    _collectionHandle: '',
};

export default SearchPageProductList;